import { gql } from "@apollo/client";
import { Content } from "components/Content";
import { Page_Flexiblecontent_Blocks_TextBlock } from "graphql";

interface TextBlockProps extends Page_Flexiblecontent_Blocks_TextBlock {
  className?: string;
}

const TextBlock = ({ className, title, content }: TextBlockProps) => {
  return (
    <section className={`${className}`}>
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 lg:px-16">
        {title === "Highlight Your Mission Through Impactful Experiences." ? (
          <>
            <h2
              className={`font-serif text-[1.3rem] md:text-[2.34375rem] font-semibold italic`}
            >
              Experienced. Reliable. Results-Driven.
              <span className="block font-normal max-w-[750px] text-3xl">
                Why We specialize in nonprofit events that run smoothly, raise
                more, and reflect your mission.
              </span>
            </h2>
            <Content
              content={`With years of experience producing galas, auctions, and fundraisers, we know how to deliver events that are both seamless and impactful.`}
              className={`mt-5 text-[1rem] md:text-[1.171875rem] leading-[1.7rem] max-w-[900px]`}
            />
            <div className="flex-1 flex flex-col lg:flex-row mt-10 max-w-[900px] lg:mb-5">
              <div className="left mb-5 lg:mb-0">
                <div className="mb-2">
                  ✔️ We help you raise more. From sponsorships to live appeals,
                  our strategies drive strong results.
                </div>
                <div>
                  ✔️ We run smooth events. Every detail is handled with
                  precision—so you can focus on your guests.
                </div>
              </div>
              <div className="right mt-[-8px] lg:mt-0">
                <div className="mb-2">
                  ✔️ We highlight your mission. We help tell your story and keep
                  your cause at the center.{" "}
                </div>
                <div>
                  ✔️ We build long-term value. A well-run event strengthens
                  donor connections and sets up future success.
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <h2
              className={`mb-5 md:mb-10 font-serif text-[1.3rem] md:text-[2.34375rem] font-semibold italic`}
            >
              <Content content={title} />
            </h2>
            <Content
              content={content}
              className={`text-[1rem] md:text-[1.171875rem] leading-[1.7rem]`}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default TextBlock;

TextBlock.fragments = {
  pageEntry: gql`
    fragment TextBlockPageFragment on Page_Flexiblecontent_Blocks_TextBlock {
      __typename
      title
      content
    }
  `,
  serviceEntry: gql`
    fragment TextBlockServiceFragment on Service_Flexiblecontent_Blocks_TextBlock {
      __typename
      title
      content
    }
  `,
};
